import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSwiftComponent } from './simple-icons-swift.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSwiftComponent ],
    exports:      [ SimpleIconsSwiftComponent ],
    bootstrap:    []
})
export class SimpleIconsSwiftModule {}
